// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lcs_wrap {
	display: inline-block;	
	direction: ltr;
	vertical-align: middle;
	margin-right: 8px;
}
.lcs_wrap input {
	display: none;	
}

.lcs_switch {
	display: inline-block;	
	position: relative;
	width: 55px;
	height: 20px;
	border-radius: 10px;
	background: #ddd;
	overflow: hidden;
	cursor: pointer;
	
	-webkit-transition: all .2s ease-in-out;  
	-ms-transition: 	all .2s ease-in-out; 
	transition: 		all .2s ease-in-out; 
}
.lcs_cursor {
	display: inline-block;
	position: absolute;
	top: 2px;	
	width: 16px;
	height: 16px;
	border-radius: 100%;
	background: #fff;
	box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2), 0 3px 4px 0 rgba(0, 0, 0, 0.1);
	z-index: 10;
	
	-webkit-transition: all .2s linear;  
	-ms-transition: 	all .2s linear; 
	transition: 		all .2s linear; 
}
.lcs_label {
	font-family: "Trebuchet MS", Helvetica, sans-serif;
    font-size: 12px;
	letter-spacing: 1px;
	line-height: 12px;
	color: #fff;
	font-weight: bold;
	position: absolute;
	width: 28px;
	top: 5px;
	overflow: hidden;
	text-align: center;
	opacity: 0;
	
	-webkit-transition: all .2s ease-in-out .1s;  
	-ms-transition: 	all .2s ease-in-out .1s;   
	transition: 		all .2s ease-in-out .1s;   
}
.lcs_label.lcs_label_on {
	left: -70px;
	z-index: 6;	
}
.lcs_label.lcs_label_off {
	right: -70px;
	z-index: 5;
	width: 22px;
}


/* on */
.lcs_switch.lcs_on {
	background: #5AAC44;
    box-shadow: 0 0 2px #579022 inset;
}
.lcs_switch.lcs_on .lcs_cursor {
	left: 37px;
}
.lcs_switch.lcs_on .lcs_label_on {
	left: 7px;	
	opacity: 1;
}


/* off */
.lcs_switch.lcs_off {
	background: #b2b2b2;
	box-shadow: 0px 0px 2px #a4a4a4 inset; 	
}
.lcs_switch.lcs_off .lcs_cursor {
	left: 3px;
}
.lcs_switch.lcs_off .lcs_label_off {
	right: 10px;
	opacity: 1;	
}


/* disabled */
.lcs_switch.lcs_disabled {
	opacity: 0.65;
	filter: alpha(opacity=65);	
	cursor: default;
}`, "",{"version":3,"sources":["webpack://./styles/jquery.lc_switch.css"],"names":[],"mappings":"AAAA;CACC,qBAAqB;CACrB,cAAc;CACd,sBAAsB;CACtB,iBAAiB;AAClB;AACA;CACC,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,mBAAmB;CACnB,gBAAgB;CAChB,gBAAgB;CAChB,eAAe;;CAEf,uCAAuC;CACvC,oCAAoC;CACpC,iCAAiC;AAClC;AACA;CACC,qBAAqB;CACrB,kBAAkB;CAClB,QAAQ;CACR,WAAW;CACX,YAAY;CACZ,mBAAmB;CACnB,gBAAgB;CAChB,0EAA0E;CAC1E,WAAW;;CAEX,kCAAkC;CAClC,+BAA+B;CAC/B,4BAA4B;AAC7B;AACA;CACC,kDAAkD;IAC/C,eAAe;CAClB,mBAAmB;CACnB,iBAAiB;CACjB,WAAW;CACX,iBAAiB;CACjB,kBAAkB;CAClB,WAAW;CACX,QAAQ;CACR,gBAAgB;CAChB,kBAAkB;CAClB,UAAU;;CAEV,2CAA2C;CAC3C,wCAAwC;CACxC,qCAAqC;AACtC;AACA;CACC,WAAW;CACX,UAAU;AACX;AACA;CACC,YAAY;CACZ,UAAU;CACV,WAAW;AACZ;;;AAGA,OAAO;AACP;CACC,mBAAmB;IAChB,iCAAiC;AACrC;AACA;CACC,UAAU;AACX;AACA;CACC,SAAS;CACT,UAAU;AACX;;;AAGA,QAAQ;AACR;CACC,mBAAmB;CACnB,qCAAqC;AACtC;AACA;CACC,SAAS;AACV;AACA;CACC,WAAW;CACX,UAAU;AACX;;;AAGA,aAAa;AACb;CACC,aAAa;CACb,yBAAyB;CACzB,eAAe;AAChB","sourcesContent":[".lcs_wrap {\r\n\tdisplay: inline-block;\t\r\n\tdirection: ltr;\r\n\tvertical-align: middle;\r\n\tmargin-right: 8px;\r\n}\r\n.lcs_wrap input {\r\n\tdisplay: none;\t\r\n}\r\n\r\n.lcs_switch {\r\n\tdisplay: inline-block;\t\r\n\tposition: relative;\r\n\twidth: 55px;\r\n\theight: 20px;\r\n\tborder-radius: 10px;\r\n\tbackground: #ddd;\r\n\toverflow: hidden;\r\n\tcursor: pointer;\r\n\t\r\n\t-webkit-transition: all .2s ease-in-out;  \r\n\t-ms-transition: \tall .2s ease-in-out; \r\n\ttransition: \t\tall .2s ease-in-out; \r\n}\r\n.lcs_cursor {\r\n\tdisplay: inline-block;\r\n\tposition: absolute;\r\n\ttop: 2px;\t\r\n\twidth: 16px;\r\n\theight: 16px;\r\n\tborder-radius: 100%;\r\n\tbackground: #fff;\r\n\tbox-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2), 0 3px 4px 0 rgba(0, 0, 0, 0.1);\r\n\tz-index: 10;\r\n\t\r\n\t-webkit-transition: all .2s linear;  \r\n\t-ms-transition: \tall .2s linear; \r\n\ttransition: \t\tall .2s linear; \r\n}\r\n.lcs_label {\r\n\tfont-family: \"Trebuchet MS\", Helvetica, sans-serif;\r\n    font-size: 12px;\r\n\tletter-spacing: 1px;\r\n\tline-height: 12px;\r\n\tcolor: #fff;\r\n\tfont-weight: bold;\r\n\tposition: absolute;\r\n\twidth: 28px;\r\n\ttop: 5px;\r\n\toverflow: hidden;\r\n\ttext-align: center;\r\n\topacity: 0;\r\n\t\r\n\t-webkit-transition: all .2s ease-in-out .1s;  \r\n\t-ms-transition: \tall .2s ease-in-out .1s;   \r\n\ttransition: \t\tall .2s ease-in-out .1s;   \r\n}\r\n.lcs_label.lcs_label_on {\r\n\tleft: -70px;\r\n\tz-index: 6;\t\r\n}\r\n.lcs_label.lcs_label_off {\r\n\tright: -70px;\r\n\tz-index: 5;\r\n\twidth: 22px;\r\n}\r\n\r\n\r\n/* on */\r\n.lcs_switch.lcs_on {\r\n\tbackground: #5AAC44;\r\n    box-shadow: 0 0 2px #579022 inset;\r\n}\r\n.lcs_switch.lcs_on .lcs_cursor {\r\n\tleft: 37px;\r\n}\r\n.lcs_switch.lcs_on .lcs_label_on {\r\n\tleft: 7px;\t\r\n\topacity: 1;\r\n}\r\n\r\n\r\n/* off */\r\n.lcs_switch.lcs_off {\r\n\tbackground: #b2b2b2;\r\n\tbox-shadow: 0px 0px 2px #a4a4a4 inset; \t\r\n}\r\n.lcs_switch.lcs_off .lcs_cursor {\r\n\tleft: 3px;\r\n}\r\n.lcs_switch.lcs_off .lcs_label_off {\r\n\tright: 10px;\r\n\topacity: 1;\t\r\n}\r\n\r\n\r\n/* disabled */\r\n.lcs_switch.lcs_disabled {\r\n\topacity: 0.65;\r\n\tfilter: alpha(opacity=65);\t\r\n\tcursor: default;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
